import type { ResolutionStatus } from '../../schema';

const LABELS: Record<ResolutionStatus, string> = {
  RESOLVED: 'Resolved',
  UNMAPPED: 'Unmapped',
  AMBIGUOUS: 'Ambiguous',
  UNSUPPORTED: 'Unsupported',
};

// Tonal pills from brand tokens. Resolved = trustworthy (success); the rest
// need a human (warning / error) — matching the "must map before approve" rule.
const TONE: Record<ResolutionStatus, string> = {
  RESOLVED: 'bg-success/[0.14] text-success',
  UNMAPPED: 'bg-warning/[0.12] text-warning',
  AMBIGUOUS: 'bg-warning/[0.12] text-warning',
  UNSUPPORTED: 'bg-error/[0.12] text-error',
};

export function ResolutionBadge({ status }: { status: ResolutionStatus }) {
  return (
    <span className="inline-flex h-full items-center">
      <span
        className={`inline-flex h-[20px] items-center rounded-full px-2 text-[11px] font-semibold uppercase tracking-wide ${TONE[status]}`}
      >
        {LABELS[status]}
      </span>
    </span>
  );
}
